import _ from "lodash";

export function orderByAvailabilityAndIdentifier(compilers, controlServers, simulators) {
  return _.orderBy(
    compilers.concat(controlServers, simulators),
    [s => Boolean(s.availableAt), "identifier"],
    ["desc", "asc"]
  );
}
